import LovrFire from '../lovrfire'
import LovrException from './LovrException'
import firebase from 'firebase'



export const authState = async (observer) => {
    LovrFire.auth().onAuthStateChanged(observer)
}


export const createUser = async (
    email,
    password,
    name,
    gender,
    isCreator,
    username,
    tags,
) => {
    /*
        schema
            username: String
            email: String
            isCreator: boolean
            name: String
            gender: int (0: male, 1: female) 
            location: String
            price: String
            id: String
            image: String
            balance: float
            bio: String
            followersCount: int
            followingCount: int
            socialMedia: Array
                instagram: String
                twitter: String
                website: String
                pornhub: String
                tiktok: String
                twitch: String
                spotify: String
                snapchat: String
            tags: Array 
    */
    try {
        const res = await LovrFire.auth().createUserWithEmailAndPassword(email.trim(), password.trim());
        const userdata = {
            balance: 0,
            bio: "Hey there, I am using Lovrapp",
            email: email,
            followersCount: 0,
            followingCount: 0,
            id: res.user.uid,
            image: isCreator == 1 ?
                'https://firebasestorage.googleapis.com/v0/b/lovr-app.appspot.com/o/admin%2Fcreatorpic.svg?alt=media&token=99f15de4-b749-4de2-af72-761d3203f949' : 'https://firebasestorage.googleapis.com/v0/b/lovr-app.appspot.com/o/admin%2Fviewerpic.svg?alt=media&token=4c5b3d2e-6c92-49de-af3a-55ee947c7715',
            socialMedia: {
                'twitter': "",
                'instagram': "",
                'twitch': "",
                'spotify': "",
                'tiktok': "",
                'website': "",
                'snapchat': "",
                'pornhub': ""
            },
            isCreator: isCreator == 1 ? true : false,
            location: "",
            name: name,
            price: "0",
            sex: gender,
            tags: tags,
            token: '',
            username: username.toLowerCase().trim(),
            thumbnail: isCreator == 1 ?
                'https://firebasestorage.googleapis.com/v0/b/lovr-app.appspot.com/o/admin%2Fcreatorpic.svg?alt=media&token=99f15de4-b749-4de2-af72-761d3203f949' : 'https://firebasestorage.googleapis.com/v0/b/lovr-app.appspot.com/o/admin%2Fviewerpic.svg?alt=media&token=4c5b3d2e-6c92-49de-af3a-55ee947c7715',
        }
        const dateres = await LovrFire.firestore().collection('users').doc(res.user.uid).set(userdata)
        return userdata
    } catch (e) {
        console.log(e)
        throw e
    }
}



export const loginUser = async (email, password, setErrorCode, rememberMe) => {
    try {
        if (rememberMe) {
            if (email.includes('@')) {
                await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
                const res = await firebase.auth().signInWithEmailAndPassword(email.trim(), password.trim());
                const userDataRes = await LovrFire.firestore().collection('users').doc(res.user.uid).get();
                return userDataRes.data();
            } else {
                const userEmail = await LovrFire.firestore().collection('users').where('username', '==', email).limit(1).get()
                if (userEmail.docs.length > 0) {
                    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
                    const res = await firebase.auth().signInWithEmailAndPassword(userEmail.docs[0].data().email.trim(), password.trim());
                    const userDataRes = await LovrFire.firestore().collection('users').doc(res.user.uid).get();
                    return userDataRes.data();
                } else {
                   // setErrorCode('auth/user-not-found');
                    throw {
                        code: 'auth/user-not-found'
                    }
                }
            }
        } else {
            await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
            const res = await firebase.auth().signInWithEmailAndPassword(email.trim(), password.trim());
            const userDataRes = await LovrFire.firestore().collection('users').doc(res.user.uid).get();
            return userDataRes.data();
        }
    } catch (e) {
        setErrorCode(e.code);
        console.log(e, " ERROR");
        throw e;
    }
}


export const updatePassword = async (password) => {
    try{
        const currentUser = await LovrFire.auth().currentUser;
        await currentUser.updatePassword(password);
        return;
    }catch(e){
        throw e
    }
}

export const updateEmail = async (email) => {
    try{
        const currentUser = await LovrFire.auth().currentUser;
        await currentUser.updateEmail(email)
        return;
    }catch(e){
        throw e
    }
}

export const currentUserAuthState = async (authObserver) => {
    LovrFire.auth().onAuthStateChanged(authObserver)
}

export const getCurrentUser = async (id, authObserver) => {
    LovrFire.firestore().collection('users').doc(id).onSnapshot(authObserver)
}

export const getUserByUsername = async (username) => {
    const res = await LovrFire.firestore().collection('users').where('username', '==', username).get();
    const resDoc = await LovrFire.firestore().collection('users').doc(res.docs[0].id).get()
    return resDoc.data();
}

export const getUserByID = async (id) => {
    const res = await LovrFire.firestore().collection('users').where('id', '==', id).get();
    const resDoc = await LovrFire.firestore().collection('users').doc(res.docs[0].id).get()
    return resDoc.data();
}

export const updateUserData = async (dataToUpdate) => {
    try {
        await LovrFire.firestore().collection('users').doc(LovrFire.auth().currentUser.uid).update(dataToUpdate);
    } catch (e) {
        throw e;
    }
}

export const logoutUser = async () => {

    await LovrFire.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    LovrFire.auth().signOut().catch((err) => {
        throw err;
    }).then(() => {
        console.log('signed out');
    })

}


export const deleteAccount = async () => {
    const userId = LovrFire.auth.currentUser.uid
    await LovrFire.firestore.collection('users').doc(userId).delete();
    await LovrFire.storage().ref(`/profilepic/${userId}`).delete();
    console.log("deleted");
}